import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { environment } from '@work-frontend-monorepo/work-environments';

export type LogoVariant = 'default' | 'white';
export type LogoContext = 'default' | 'office';

@Component({
  selector: 'work-ui-logo',
  standalone: true,
  imports: [NgClass],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent {
  @Input() variant: LogoVariant = 'default';
  @Input() context: LogoContext = 'default';
  protected readonly environment = environment;
}
